// @flow
import React from 'react'
import { Redirect } from 'react-router-dom'
import Success from 'components/LeadGenForm/Success'

import { Store } from 'Store'

type Props = {
    location: Location
}

export default (props: Props) => {
    const { state } = React.useContext(Store)

    if (!state.lead) {
        return <Redirect to={`${props.location.pathname.replace('/success', '')}${props.location.search}`} push />
    }

    return (
        <Success />
    )
}
